const fragment = `
  id
  hashId
  name
  description
  createdAt
  company {
    id
    name
  }
  activeUsersCount
  userPermission
`;

export const listTeamsQuery = `
  query ListTeams(
    $filter: TeamFilterInput
  ) {
    items: listTeams(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getTeamQuery = `
  query GetTeam($id: Int!) {
    item: getTeam(id: $id) {
      ${fragment}
    }
  }
`;

export const createTeamQuery = `
  mutation CreateTeam(
    $input: CreateTeamInput!
  ) {
    item: createTeam(input: $input) {
      ${fragment}
    }
  }
`;

export const updateTeamQuery = `
  mutation UpdateTeam(
    $input: UpdateTeamInput!
  ) {
    item: updateTeam(input: $input) {
      ${fragment}
    }
  }
`;

export const deleteTeamQuery = `
  mutation DeleteTeam(
    $id: Int!
  ) {
    item: deleteTeam(id: $id) {
      ${fragment}
    }
  }
`;
